import _ from 'underscore';
import { BaseSchemaProcessor } from './base-schema-processor';

export class PmaxAssetLinkSchemaProcessor extends BaseSchemaProcessor {
  updateEntitySchemaForFeatures(entitySchema) {
    const updatedSchema = super.updateEntitySchemaForFeatures(entitySchema);

    updatedSchema.properties.EditorialStatus = _.defaults({
      enum: [
        "Enum.EditorialStatus'Approved'",
        "Enum.EditorialStatus'ApprovedLimited'",
        "Enum.EditorialStatus'Rejected'",
        "Enum.EditorialStatus'Pending'",
      ],
      enumValueMap: {
        "Enum.EditorialStatus'Approved'": 'Approved',
        "Enum.EditorialStatus'ApprovedLimited'": 'ApprovedLimited',
        "Enum.EditorialStatus'Rejected'": 'Rejected',
        "Enum.EditorialStatus'Pending'": 'Pending',
      },
    }, updatedSchema.properties.EditorialStatus);

    updatedSchema.properties.AssociationType = _.defaults({
      enum: [
        "Enum.AssetAssociationType'Headlines'",
        "Enum.AssetAssociationType'LongHeadlines'",
        "Enum.AssetAssociationType'Descriptions'",
        "Enum.AssetAssociationType'ImageMedia1X2'",
        "Enum.AssetAssociationType'SquareImageMedia'",
        "Enum.AssetAssociationType'ImageMedia133X100'",
        "Enum.AssetAssociationType'ImageMedia15X10'",
        "Enum.AssetAssociationType'ImageMedia178X100'",
        "Enum.AssetAssociationType'LandscapeImageMedia'",
        "Enum.AssetAssociationType'ImageMedia4X1'",
        "Enum.AssetAssociationType'SquareLogoMedia'",
        "Enum.AssetAssociationType'LandscapeLogoMedia'",
        "Enum.AssetAssociationType'CallToAction'",
      ],
      enumValueMap: {
        "Enum.AssetAssociationType'Headlines'": 'Headlines',
        "Enum.AssetAssociationType'LongHeadlines'": 'LongHeadlines',
        "Enum.AssetAssociationType'Descriptions'": 'Descriptions',
        "Enum.AssetAssociationType'ImageMedia1X2'": 'ImageMedia1X2',
        "Enum.AssetAssociationType'SquareImageMedia'": 'SquareImageMedia',
        "Enum.AssetAssociationType'ImageMedia15X10'": 'ImageMedia15X10',
        "Enum.AssetAssociationType'ImageMedia133X100'": 'ImageMedia133X100',
        "Enum.AssetAssociationType'ImageMedia178X100'": 'ImageMedia178X100',
        "Enum.AssetAssociationType'LandscapeImageMedia'": 'LandscapeImageMedia',
        "Enum.AssetAssociationType'ImageMedia4X1'": 'ImageMedia4X1',
        "Enum.AssetAssociationType'SquareLogoMedia'": 'SquareLogoMedia',
        "Enum.AssetAssociationType'LandscapeLogoMedia'": 'LandscapeLogoMedia',
        "Enum.AssetAssociationType'CallToAction'": 'CallToAction',
      },
    }, updatedSchema.properties.AssociationType);

    updatedSchema.properties.AssetAssetSource = _.defaults({
      chooseType: 'checkbox',
      enumType: 'AssetSource',
      enum: [
        "Enum.AssetSource'AdvertiserProvided'",
        "Enum.AssetSource'AutoGenerated'",
      ],
      enumValueMap: {
        "Enum.AssetSource'AdvertiserProvided'": 'AdvertiserProvided',
        "Enum.AssetSource'AutoGenerated'": 'AutoGenerated',
      },
    }, updatedSchema.properties.AssetAssetSource);

    updatedSchema.properties = _.pick(updatedSchema.properties, 'AssetText', 'AssociationType', 'EditorialStatus', 'PerformanceMetricsImpressions', 'PerformanceMetricsAdvertiserReportedRevenue', 'PerformanceMetricsConversionsCredit', 'AssetId', 'AssetAssetSource');

    return updatedSchema;
  }
}
